<ngx-spinner></ngx-spinner>
<div>
  <!-- <mat-toolbar color="primary">
    <a class="title" href="/">{{ title }}</a>

    <div class="toolbar-spacer"></div>
    <button style="position: relative;
    left: 1049px;
    background-color: #99C43C;" mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>
    <button style="position: relative;
    left: 1049px;" mat-raised-button color="accent" *ngIf="loginDisplay" (click)="logout()">Logout</button>
  </mat-toolbar> -->
  <div class="container"></div>
</div>
<!-- <a mat-button [routerLink]="['login']">Guarded Component</a> -->
<!-- <router-outlet></router-outlet> -->
<div *ngIf="loginDisplay">
  <mat-toolbar>
    <mat-toolbar-row>
      <!--class="justify-content-between" remove by shivam modi-->
      <button mat-icon-button (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <!--code add by shivam modi -->
      <div class="mat-toolbar-row justify-content-between">
        <div class="new-logo">
          <img
            src="./assets/logo1.png"
            alt="Company Logo"
            style="height: 60px; margin-left: -14px"
          />
        </div>
        <!--code add by shivam modi -->

        <div class="row mr-2 ml-auto">
          <ul class="row m-0 align-items-center">
            <li>
              <button
                mat-button
                [matMenuTriggerFor]="menu"
                class="user mt-2 d-flex align-items-center"
                style="margin-right: -30px"
              >
                <img
                  src="./assets/userImg.png"
                  alt=""
                  class="user-image mr-1 p-2"
                />
                {{ name }}
                <mat-icon class="user-image-icon ml-1"
                  >keyboard_arrow_down</mat-icon
                >
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="logout()">
                  <mat-icon>exit_to_app</mat-icon>
                  Logout
                </button>
              </mat-menu>
            </li>
          </ul>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="example-container" autosize>
    <mat-sidenav #drawer mode="side" opened role="navigation">
      <mat-nav-list style="margin-top: 62px"
        ><!--inline css add by shivam modi -->
        <!--code comment by shivam modi start or -->
        <!-- <div class="logo py-4">
          <img src="./assets/logo1.png" alt="Company Logo" />
        </div> -->
        <!--code comment by shivam modi start end -->
        <mat-divider></mat-divider><br />

        <!-- <a mat-list-item routerLinkActive="list-item-active" (click)="gotoPage()">
    <mat-icon>home</mat-icon> Home
  </a> -->
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['1'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          (click)="gotoPage()"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/usericon.png"
              height="30"
              width="30"
          /></mat-icon>
          Users
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['3'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/market-rate-historical-data"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/marketrateicon.png"
              height="30"
              width="30"
          /></mat-icon>
          Market Rate Updates
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['12'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/product-list"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/product-icon.png"
              height="30"
              width="30"
          /></mat-icon>
          Products
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['15'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/transaction-list"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/transaction.png"
              height="30"
              width="30"
          /></mat-icon>
          Transactions
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['8'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/ask-an-expert"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/asking.png"
              height="30"
              width="30"
          /></mat-icon>
          Ask An Expert
        </a>

        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['2'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/document"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/documenIcon.png"
              height="30"
              width="30"
          /></mat-icon>
          Document Verification
        </a>

        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['11'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/news-historical-data"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/news.png"
              height="30"
              width="30"
          /></mat-icon>
          News
        </a>

        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['9'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/add-blog-list"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/listblog.png"
              height="30"
              width="30"
          /></mat-icon>
          Blogs
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['4'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/Govt-schemes-list"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/govtIcon.png"
              height="30"
              width="30"
          /></mat-icon>
          Govt Schemes
        </a>
        <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/Fertilizer">
          <mat-icon><img class="iconposition" src="./assets/FertilizerReminderIcon.png" height="30" width="30"></mat-icon> Fertilizer Reminder
        </a> -->
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['5'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/FertilizerList"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/FertilizerListIcon.png"
              height="30"
              width="30"
          /></mat-icon>
          Reminders
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['7'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/track-your-harvest"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/TrackYourHarvest.png"
              height="30"
              width="30"
          /></mat-icon>
          Track Your Harvest
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['10'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/survey-data"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/survey.png"
              height="30"
              width="30"
          /></mat-icon>
          Survey
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['6'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/in-app-review"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/InappReviewIcon.png"
              height="30"
              width="30"
          /></mat-icon>
          In App Review
        </a>

        <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/add-blog">
          <mat-icon><img class="iconposition" src="./assets/creatblog.png" height="30" width="30"></mat-icon> Add Blog post
        </a> -->
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['14'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/discussionboard"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/discussion-board.png"
              height="30"
              width="30"
          /></mat-icon>
          Discussion Board
        </a>

        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['13'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/access-control"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/accessControl.png"
              height="30"
              width="30"
          /></mat-icon>
          Access Control
        </a>
        <a
          mat-list-item
          [hidden]="
            !(menusObj ? menusObj['14'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/setting"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/settings.png"
              height="30"
              width="30"
          /></mat-icon>
          Setting
        </a>

        <!---------------------------------------New code start ------------------------------------------->
        <a
          mat-list-item
          [hidden]="
          !(menusObj ? menusObj['17'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/banner-Management"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/banner.png"
              height="30"
              width="30"
          /></mat-icon>
          Banner Management
        </a>
        <a
          mat-list-item
          [hidden]="
          !(menusObj ? menusObj['18'] : true) && UserRole !== 'SUPERADMIN'
          "
          routerLinkActive="list-item-active"
          routerLink="/video-library"
        >
          <mat-icon
            ><img
              class="iconposition"
              src="./assets/video.png"
              height="30"
              width="30"
          /></mat-icon>
          Video Library
        </a>
        <!---------------------------------------New code  end------------------------------------------->

        <!-- <a mat-list-item [hidden]="!(menusObj ? menusObj['14'] : true) && UserRole !== 'SUPERADMIN'" routerLinkActive="list-item-active" routerLink="/discussionboard">
          <mat-icon><img class="iconposition" src="./assets/settings.png" height="30" width="30"></mat-icon> Discussion Board
        </a> -->

        <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/news-historical-data">
          <mat-icon><img class="iconposition" src="./assets/news.png" height="30" width="30"></mat-icon> News
        </a> -->
        <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/product-list">
          <mat-icon><img class="iconposition" src="./assets/product-icon.png" height="30" width="30"></mat-icon> Products
        </a> -->

        <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/add-news">
          <mat-icon><img class="iconposition" src="./assets/asking.png" height="30" width="30"></mat-icon> add news
        </a> -->
        <!-- <a mat-list-item> <mat-icon>edit</mat-icon>BuyAndSellAnalytics</a>
  <a mat-list-item> <mat-icon>edit</mat-icon>Daily Updates</a>
  <a mat-list-item> <mat-icon>edit</mat-icon>Tickets</a>
  <a mat-list-item> <mat-icon>edit</mat-icon>Notification </a> -->
      </mat-nav-list>
    </mat-sidenav>
    <!--To Load Center Content-->
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
